
<template>
  <div class="wrapper">
    <el-row>
      <el-col class="top_tips">Paypal账号：{{this.email}}</el-col>
    </el-row>
    <el-row>
      <el-col class="top_tips" v-if="this.show_data.dispute_outcome&&this.show_data.dispute_outcome.outcome_code&&this.show_data.dispute_outcome.outcome_code=='RESOLVED_BUYER_FAVOUR'" >买家胜诉。</el-col>
      <el-col class="top_tips" v-else-if="this.show_data.dispute_outcome&&this.show_data.dispute_outcome.outcome_code&&this.show_data.dispute_outcome.outcome_code=='RESOLVED_SELLER_FAVOUR'" >卖家胜诉，无需承担责任。</el-col>
      <el-col class="top_tips" v-else-if="this.show_data.status=='WAITING_FOR_SELLER_RESPONSE'">为尽快解决您的事件，我们需要您在{{ $moment(this.show_data.seller_response_due_date).format("YYYY年MM月DD日 H:m:s") }}前作出回应。</el-col>
      <el-col class="top_tips" v-else-if="this.show_data.status=='WAITING_FOR_BUYER_RESPONSE'" e>买家在{{ $moment(this.show_data.buyer_response_due_date).format("YYYY年MM月DD日 H:m:s") }}或之前回复您。</el-col>

    </el-row>
    <el-row>
      <el-col :span="12" class="base-el-col">事件编号：{{ this.show_data.dispute_id }}</el-col>
      <el-col :span="12" class="base-el-col" >争议金额：{{ this.show_data.dispute_amount.value }}{{ this.show_data.dispute_amount.currency_code }}</el-col>

      <el-col :span="12" class="base-el-col">姓名：{{this.show_data.disputed_transactions[0].buyer.name}}</el-col>
      <el-col :span="12" class="base-el-col">邮箱：{{ this.buyer_email }}</el-col>
      <el-col :span="12" class="base-el-col" style="display: flex">
        <div>收货地址：</div>
        <div v-if="this.show_data.transactions[0].transaction_details.length>0">
          <div>{{this.show_data.transactions[0].transaction_details[0].shipping_info.address.line1}} </div>
          <div>{{this.show_data.transactions[0].transaction_details[0].shipping_info.address.state?this.show_data.transactions[0].transaction_details[0].shipping_info.address.state:''}}</div>
          <div>{{this.show_data.transactions[0].transaction_details[0].shipping_info.address.city}}  {{this.show_data.transactions[0].transaction_details[0].shipping_info.address.postal_code}}</div>
        </div>

         </el-col>
      <el-col :span="12" class="base-el-col">报告日期：{{ $moment(this.show_data.create_time).format("YYYY年MM月DD日") }} {{ $moment(this.show_data.create_time).format("HH:mm:ss") }}</el-col>
      <el-col :span="12" class="base-el-col">账单号：{{this.show_data.disputed_transactions[0].invoice_number}} </el-col>
      <el-col :span="12" class="base-el-col">交易号：{{ this.show_data.disputed_transactions[0].seller_transaction_id }}</el-col>
      <el-col :span="12" class="base-el-col">交易金额：{{ this.show_data.disputed_transactions[0].gross_amount.value }}{{ this.show_data.disputed_transactions[0].gross_amount.currency_code }}</el-col>

    </el-row>
    <el-row v-if="this.evidenceLog.length>0">
      <el-col :span="24" class="goods-title"><div>您的回复</div></el-col>
      <div  v-for="(item,index) in evidenceLog" :key="index">
        <div class="evidence_div" v-if="item.evidence_type&&item.notes&&item.source == 'SUBMITTED_BY_SELLER' ">
          <p>{{ $moment(item.date).format("YYYY年MM月DD日 H:m:s") }}</p>
          <div v-if="item.action_info">
            <div v-if="item.action_info.action == 'ESCALATE' ">
              <p>您已上报此问题。</p>
              <p>上报信息</p>
              <p>{{item.notes}}</p>
            </div>
            <div v-else-if="item.action_info.action == 'PROVIDE_EVIDENCE'&&item.evidence_type=='PROOF_OF_FULFILLMENT' ">
              <p>您已提供订单履行信息作为证据。</p>
              <p>{{item.notes}}</p>
              <div v-if="item.evidence_info&&item.evidence_info.tracking_info">
                <div v-for="(evi_info,evi_info_index) in item.evidence_info.tracking_info" :key="evi_info_index">
                  <p>承运商：{{evi_info.carrier_name}}</p>
                  <p>{{evi_info.tracking_number}}</p>
                </div>
              </div>
            </div>
            <div v-else-if="item.action_info.action == 'ACCEPT_CLAIM'&&item.action_info.response_option=='PARTIAL_REFUND' ">
              <p>您已送提议。</p>
              <p>提议详情：部分退款</p>
              <p>退款金额：{{item.history.offer_amount.value}}{{item.history.offer_amount.currency_code}}</p>
              <p>留言：{{item.notes}}</p>
            </div>
            <div v-else-if="item.action_info.action == 'PROVIDE_EVIDENCE'&&item.evidence_type=='OTHER' ">
              <p>您已提供以下证明信息。</p>
              <p>{{item.notes}}</p>
            </div>
            <div v-else-if="item.action_info.action == 'ACCEPT_CLAIM'&&item.action_info.response_option=='REFUND_WITH_RETURN' ">
              <p>您已送提议。</p>
              <p>提议详情：退货并全额退款</p>
              <p>退款金额：{{item.history.offer_amount.value}}{{item.history.offer_amount.currency_code}}</p>
              <p>退货地址：{{returnAddress}}</p>
              <p>留言：{{item.notes}}</p>
            </div>
          </div>
          <div v-else >
            <p>您已提供其他信息。</p>
            <p>{{item.notes}}</p>
          </div>
        </div>
        <div class="evidence_div" v-else-if="item.notes&&item.source == 'SUBMITTED_BY_SELLER'">
          <p>{{ $moment(item.provided_time).format("YYYY年MM月DD日  H:m:s") }}</p>
          <p>您已提供其他信息。</p>
          <p>{{item.notes}}</p>
        </div>

        <div class="evidence_div" v-else-if=" item.source == 'SUBMITTED_BY_BUYER'">
          <div v-if="item.evidence_type == 'PROOF_OF_RETURN' ">
            <p>{{ $moment(item.date).format("YYYY年MM月DD日 H:m:s") }}</p>
            <p>以下是买家所退回物品的跟踪信息。您确认收到物品后，我们将进行退款并结束此事件。</p>
            <div v-for="(evi_info,evi_info_index) in item.evidence_info.tracking_info" :key="evi_info_index">
              <p>{{evi_info.tracking_number}}</p>
              <p>承运商：{{evi_info.carrier_name}}</p>
            </div>
            <button class="note_pay" @click="acknowledge" v-if="this.show_data.dispute_state=='REOUIRED_ACTION'">通知PayPal</button>
          </div>

        </div>

        <div class="evidence_div" v-for="(doc,doc_index) in item.documents" :key="doc_index" @click="downloadFile(email,doc.name,doc.url)">
          <p class="download_css">{{doc.name}}</p>
        </div>

      </div>

    </el-row>
    <el-row>
      <el-col :span="24" class="goods-title"><div>商品详情</div></el-col>
    </el-row>

    <el-table
        :data="tableData"
        max-height="250"
        border
        style="width: 100%">
      <el-table-column
          prop="item_name"
          label="物品名称">
      </el-table-column>
      <el-table-column
          prop="item_description"
          label="物品描述">
      </el-table-column>
      <el-table-column
          prop="item_quantity"
          label="商品数量">
      </el-table-column>
      <el-table-column
          prop="reason"
          label="原因">
        <template slot-scope="scope">
          {{ $t( 'disputed_reason.' + scope.row.reason ) }}
        </template>
      </el-table-column>
    </el-table>

    <el-row>
      <el-col :span="24" class="goods-title"><div>消息记录</div></el-col>
    </el-row>
    <el-table
        :data="messages"
        height="250"
        border
        style="width: 100%">
      <el-table-column
          prop="time_posted"
          label="时间">
        <template slot-scope="scope">
          {{ $moment(scope.row.time_posted).format("YYYY年MM月DD日 HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column
          label="内容">
          <template slot-scope="scope">
            <div v-if="scope.row.offer">
              {{ scope.row.content }}
              <div v-if="scope.row.offer.actor == 'BUYER' ">
                <div class="offer_div" v-if="scope.row.offer.event_type == 'DENIED'">已拒绝提议</div>
              </div>
              <div v-else>
                  <el-row class="offer_div" v-if="scope.row.offer.event_type == 'PROPOSED' ">
                    <div v-if="scope.row.offer.offer_type == 'REFUND_WITH_RETURN' ">
                      <el-col class="offer-title">退货并全额退款</el-col>
                      <el-col>退款金额：</el-col>
                      <el-col>{{scope.row.offer.offer_amount.value}}{{scope.row.offer.offer_amount.currency_code}}</el-col>
<!--                      <el-col>退货地址</el-col>-->
<!--                      <el-col>{{scope.row.offer.offer_amount.value}}{{scope.row.offer.offer_amount.currency_code}}</el-col>-->
                    </div>
                    <div v-else-if="scope.row.offer.offer_type == 'REPLACEMENT_WITHOUT_REFUND' ">
                      <el-col class="offer-title">换货</el-col>
                    </div>
                    <div v-else-if="scope.row.offer.offer_type == 'REFUND_WITH_REPLACEMENT' ">
                      <el-col class="offer-title">换货并部分退款</el-col>
                      <el-col>退款金额：</el-col>
                      <el-col>{{scope.row.offer.offer_amount.value}}{{scope.row.offer.offer_amount.currency_code}}</el-col>
                    </div>
                    <div v-else-if="scope.row.offer.offer_type == 'REFUND_WITH_RETURN' ">
                      <el-col class="offer-title">退货并部分退款</el-col>
                      <el-col>退款金额：</el-col>
                      <el-col>{{scope.row.offer.offer_amount.value}}{{scope.row.offer.offer_amount.currency_code}}</el-col>
                    </div>
                    <div v-else-if="scope.row.offer.offer_type == 'REFUND' ">
                      <el-col class="offer-title">部分退款</el-col>
                      <el-col>退款金额：</el-col>
                      <el-col>{{scope.row.offer.offer_amount.value}}{{scope.row.offer.offer_amount.currency_code}}</el-col>
                    </div>
                  </el-row>
              </div>
            </div>
            <div v-else>
              {{ scope.row.content }}
              <div v-if="scope.row.documents">
                <p class="download_css"  v-for="(item,index) in scope.row.documents" :key="index" @click="downloadFile(email,item.name,item.url)">
                  {{item.name}}
                </p>
              </div>
            </div>

          </template>
      </el-table-column>
      <el-table-column
          prop="posted_by"
          label="回复人">
        <template slot-scope="scope">
          {{ $t( 'disputed_base.' + scope.row.posted_by ) }}
        </template>
      </el-table-column>

    </el-table>

    <el-row style="margin-top: 10px" v-if="this.queue_status == 0" >
      <el-col :span="24" class="goods-title"><div>其他操作</div></el-col>
      <el-button type="primary" @click="preprocess_agree([])">通过</el-button>
      <el-button type="danger"  @click="preprocess_refuse([])">拒绝</el-button>
    </el-row>



  </div>

</template>

<script>
import {uploadImage} from "../../../utils/fileUpload";
export default {
  name: "Detail",
  props: ['email', 'dispute_id','detail_data','preprocess_id','detail_id','buyer_email','queue_status'],
  components: {
  },
  data(){
    return{
      tableData:[],
      lastData:[],
      messages:[],
      show_data:this.detail_data,
      return_msg:'',
      button_arr:[],
      fileList: [],
      imgList:[],
      evidenceLog:[],
      refundVisible:false
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    //通过预处理
    preprocess_agree(){
      var _this = this;
      var data = {
        ids:[_this.preprocess_id].join(','),
      };
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.http.fetchPut(this.api.preprocess_agree, data).then((res) => {
        if(res.data.code == 200){
          setTimeout(() => {
            loading.close();
            this.$message(res.data.msg);
            this.$emit('detailHand');
            this.$emit('getData',1,_this.per_page);
          }, 1000);
        }else{
          loading.close();
          this.$message(res.data.msg);
        }
      }).catch(err => {
        this.$message('服务器错误');
        loading.close();
        console.log(err);
      })
    },
    //拒绝预处理
    preprocess_refuse(){
      var _this = this;
      //增加备注信息
      this.$prompt('请输入拒绝理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        var data = {
          ids:[_this.preprocess_id].join(','),
          remark:value
        };

        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        _this.http.fetchPut(_this.api.preprocess_refuse, data).then((res) => {
          if(res.data.code == 200){
            setTimeout(() => {
              loading.close();
              this.$message(res.data.msg);
              _this.getData(1,_this.per_page)
              this.$emit('detailHand');
              this.$emit('getData',1,_this.per_page);
            }, 1000);
          }else{
            loading.close();
            this.$message(res.data.msg);
          }
        }).catch(err => {
          this.$message('服务器错误');
          loading.close();
          console.log(err);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作成功'
        });
      });



    },
    downloadFile(email,name,url) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(function (){
        loading.close();
      },500)
      this.http.fetchGet(this.api.download, {email: email, name: name,url:url}).then((res) => {
        if(res.data.code == 200){
          window.open(res.data.data, '_blank');
        }else{
          alert('打开失败');
        }
      })
    },
    changeVDetailLoading(){
      this.$emit('changeVDetailLoading',this.email,this.dispute_id,this.detail_id);
    },
    getData(bool = false){
      if(!bool) this.show_data = this.detail_data
      var _this = this;
      if(_this.show_data.disputed_transactions){
        _this.tableData = _this.show_data.disputed_transactions[0].items;
        if(_this.show_data.messages){
          _this.messages = _this.show_data.messages.reverse();
        }
        let offer = [];

        if(_this.show_data.offer.history&&_this.show_data.offer.history.length>0){
          let msg = _this.messages;
          offer = _this.show_data.offer.history.reverse();
          for(let of_item in offer){
            for( let msg_item in msg){
              if(offer[of_item].offer_time == msg[msg_item].time_posted && offer[of_item].actor == msg[msg_item].posted_by){
                msg[msg_item].offer = offer[of_item];
                continue;
              }
            }
          }
          _this.messages = msg;
        }
      }
      let evidence_log = [];
      //获取证据和其他支持信息
      if(_this.show_data.evidences && _this.show_data.evidences.length>0){
        for(let evi_item in _this.show_data.evidences){
          if(_this.show_data.evidences[evi_item].evidence_type != 'CREATE'){
            evidence_log.push(_this.show_data.evidences[evi_item])
          }
        }
      }
      if(_this.show_data.supporting_info && _this.show_data.supporting_info.length>0){
        for(let sup_item in _this.show_data.supporting_info){
            evidence_log.push(_this.show_data.supporting_info[sup_item])
        }
      }
      //对证据信息进行排序
      if(evidence_log.length>0){
        for(let evi_item in evidence_log ){
          //整合证据信息和金额的关联
          if(evidence_log[evi_item].action_info&&evidence_log[evi_item].action_info.action == 'ACCEPT_CLAIM'){
            for(let his_item in this.show_data.offer.history){
              if(this.show_data.offer.history[his_item].offer_time == evidence_log[evi_item].date){
                evidence_log[evi_item].history = this.show_data.offer.history[his_item];
              }
            }
          }
          if(evidence_log[evi_item].provided_time){
            evidence_log[evi_item].date = evidence_log[evi_item].provided_time;
          }
        }

        _this.evidenceLog = evidence_log;
      }
      //处理按钮部分
      if (_this.show_data.links){
        _this.button_arr = [];
        for (let item in _this.show_data.links){
          _this.button_arr.push(_this.show_data.links[item]['rel']);
        }
      }
      //处理有accept_clim
      if(_this.show_data.allowed_response_options&&_this.show_data.allowed_response_options.accept_claim.accept_claim_types.length >1){
        _this.button_arr.push('show_accept_cliam');
      }
    },
    // 图片上传
    handleSuccess(response, file, fileList) {
      console.log(response)
      console.log(file)
      console.log(fileList)
    },

    handleRemove(file, fileList) {
      this.imgList.splice(this.imgList.indexOf(file.name), 1);
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(){
      this.$message.error('最多只能上传5张图片');
    },

    handleChange(file, fileList) {
      // 使用 FormData
      let fd = new FormData();
      fd.append('file', file.raw);
      // 二次封装的 axios
      uploadImage(this.api.upload, fd).then(res => {
        var data = res.data;
        if (data.code === 200) {
          this.imgList.push(data.data.filename)
          this.fileList = fileList
        }else{
          this.fileList = this.imgList;
          alert('上传失败')
        }
      }).catch(error => {
        console.log(error)
        this.$message.error('上传失败');
        const targetElement = document.querySelector('.el-upload-list--picture');
        const lastDiv = targetElement.lastElementChild;
        if (lastDiv) {
          targetElement.removeChild(lastDiv);
        }
      });
    },
  //  通知PAYPAL
  },
  computed:{
    returnAddress(){
      if(this.show_data.extensions&&this.show_data.extensions.merchandize_dispute_properties&&this.show_data.extensions.merchandize_dispute_properties.return_shipping_address){
        return `${this.show_data.extensions.merchandize_dispute_properties.return_shipping_address.address_line_1} ${this.show_data.extensions.merchandize_dispute_properties.return_shipping_address.address_line_2} ${this.show_data.extensions.merchandize_dispute_properties.return_shipping_address.admin_area_1} ${this.show_data.extensions.merchandize_dispute_properties.return_shipping_address.admin_area_2} ${this.show_data.extensions.merchandize_dispute_properties.return_shipping_address.postal_code} ${this.show_data.extensions.merchandize_dispute_properties.return_shipping_address.country_code}`;
      }else{
        return  '';
      }

    }
  },
  watch: {
    buyer_email: function (newData) {
      if (newData){
        this.buyer_email = newData;
      }
    },
    detail_id: function (newData) {
      if (newData){
        this.detail_id = newData;
      }
    },
    detail_data: function (newData) {
      if(newData.create_time){
        this.detail_data = newData;
        this.getData();
      }
    },
    email: function (newData) {
      if (newData){
        this.email = newData;
      }
    },
    dispute_id: function (newData) {
      if (newData){
        this.dispute_id = newData;
      }
    },
    preprocess_id: function (newData) {
      if (newData){
        this.preprocess_id = newData;
      }
    },
    per_page:function (newData) {
      if (newData){
        this.per_page = newData;
      }
    },
    queue_status:function (newData) {
      if (newData){
        this.queue_status = newData;
      }
    },
  },
}
</script>

<style scoped>
.download_css{
  color:blue;
  cursor: pointer;
}
.note_pay{
  padding: 10px;

}
.evidence_div{
  border-bottom: 1px solid #E8E8E8;
  padding: 10px;
}
.evidence_div p{
  font-size: 16px;
  line-height: 30px;
}
.offer-title{
  font-weight: bold;

}

.offer_div{
  padding: 10px;
  border: 1px solid #cbd2d6;
  background-color: #faf8f5;
}
.top_tips{
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  margin-top: 10px;
  font-weight: bold;
}
.ret_msg{
  margin-top: 10px;
  width: 80%;
  height: 139px;
}
.wrapper{
  height: 700px;
  overflow: auto;
}
.base-el-col{
  line-height: 30px;
}
.goods-title{
  height: 40px;
  line-height: 40px;
  font-size: 22px;
  margin-top: 10px;
}
</style>
